module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex align-center inline-checkbox-outer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "radio",
    attrs: {
      "type": "radio",
      "name": _vm.group
    },
    domProps: {
      "checked": _vm._q(_vm.value, null)
    },
    on: {
      "change": function($event) {
        _vm.value = null
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "input__inline-label",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + " "), (_vm.required) ? _c('span', {
    staticClass: "input__asterisk"
  }, [_vm._v("*")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca4a1314","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputRadio.vue
// module id = 618
// module chunks = 0